import { integer } from "aws-sdk/clients/cloudfront";
import { int } from "aws-sdk/clients/datapipeline";
import { Json } from "aws-sdk/clients/robomaker";
import { bool } from "aws-sdk/clients/signer";
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';

export class UserData {
  userName: string;
  custExtId: string;
  isCognitoUser: boolean;
  isadmin: string;
  deptExtId: string[];
  id: integer;
  isMMP: string;
  firstName: string;
  middleName: string;
  lastName: string;
  roleId: integer;
  authorExtId: string;
  MobileNo: string;
  password: string;
  isMFA: boolean;
  allowTranscriptEditing: boolean;
  TenantId: string;
  emailTemplateId: integer;
  email: string;
  addNSAuthor: boolean;
  profile: string;
  webSite: string;
  homeDirectory: string;
  bucket: string;
  status: string;
  isActive: boolean;
  hostTenants: string;
  isSuperAuthor: boolean;
  mmpDefaultDepartment:string;
  address1 : string;
  address2 : string;
  isEmailDistribution : boolean;
  newPassword : string;
  isPasswordOnNextLogin : boolean;
}
export class UserConfigInputModel {
  userData: UserData;
  pooldata: PollDataModel;
}
export class PollDataModel {
  UserPoolId: string;
  Username: string;
  TemporaryPassword?: string;
  DesiredDeliveryMediums?: string[];
  MessageAction?: string;
  UserAttributes: UserAttribute[];
  IsResend:boolean;
}
export class UserAttribute {
  Name: string;
  Value: string;
}
export class RegistrationUser {
  name: string;
  email: string;
  phone_number: string;
  password: string;
  resend: boolean;
  organization: Organizations;
  Isadmin: boolean;
  IsMMP: boolean;
  id: integer;
  firstName: string;
  middleName: string;
  lastName: string;
  roleId: integer;
  authorExtId: string;
  IsMFA: boolean;
  allowTranscriptEditing: boolean;
  TenantId: string;
  EmailProfile: string;
  ncUrl: string;
  addNSAuthor: boolean;
  isActive: boolean;
  status: string;
  hostTenants: string;
  IsSuperAuthor: boolean;
  mmpDefaultDepartment:string;
  address1:string;
  address2:string;
  isEmailDistribution: boolean;
  newPassword : string;
  isPasswordOnNextLogin : boolean;
}
export class Organizations {
  id: string;
  customerName: string;
  custExtId: string;
  directBucket: string;
  deptExtId: string[];
  ncurl: string;
  tenantId: int;
  tenantName: string;
  emailTemplateId: string;
}
export class Tenants {
  id: string;
  tenancyName: string;
  ncurl: string;
  tenantId: int;
}
export class NewPasswordUser {
  username: string;
  existingPassword: string;
  confirmationCode: string;
  confirmationpassword: string;
  password: string;
}
export class pageParamsDto {
  pageNumber: string;
  pageSize: string;
}
export class LoggingModel {
  type: string;
  message: string;
  dateTime: string;
  status: string;
}
export class FileToUpload {
  fileName: string = "";
  fileSize: number = 0;
  fileType: string = "";
  lastModifiedTime: number = 0;
  lastModifiedDate: Date = null;
  fileAsBase64: string = "";
  // Optional properties
  FileName?: string;
  size?: number;
  type?: string;
  lastModified?: number;
  name?: string;
  rawFile?: File;
   constructor(init?: Partial<FileToUpload>) {
    Object.assign(this, init);
  }
}
export class JobCreateInputDto {
  fileName: string = "";
  formTypeId: string = "";
  departmentId: string = "";
  FormData: any;
  AuthorId: string = "";
  AuthorExtId: string = "";
  AuthorKey: string = "";
  referenceId = "";
  callbackUrl = "";
  attachmentFiles: FileToUpload[];
  audioFiles: FileToUpload[];
  createdDate: string = "";
  notes: string = "";
  language: string = "";
  jobTypeExtId: string = "";
  JobTypeDisplayName: string = "";
  dictatedDate: string = "";
  sensitive: bool = false;
  certificateRequired: bool = false;
  isForeignLanguage: bool = false;
  isForeignLanguageFirstDraft: bool = false;
  CustomerNotes: string = "";
  isZip: bool = false;
  zipPath: string = "";
  formattedDictatedDate: string = "";
  oTAudioFileNames: string = "";
  foreignLanguageType: string;
  notarization: bool = false;
  ForeignLanguageServiceType: number;
  targetLanguage: string;
  totalEstimationCost: number;
  numberofMinutesforEstimation: number;
  perMinuteEstimationRate = "";
  type : string;
  isRush : bool = false;
  isRecording :boolean = false;
  recordingSessionId: string;
}
export class JobCreateDto {
  jobId: string = "";
  mediaFileUploadUrl: string = "";
  message: string = "";
  filename: string = "";
  jobAttachmentUrl: [];
  multipleAudioFilesUrl = [];
}
export class TenantsDto {
  tenancyName: string = '';
  tenantID: string = '';
  ncurl: string = '';
  id: number = 0;
  isDelete: bool = false;
  isActive: bool = false;
  inboundPassword: string = '';
  EmailTemplateId: number = 1;
  SupportContactNo: string;
  SupportEmail: string;
  tncjson: string;
  RecipientEmail: string;
  estimationMessage:string;
  isCustomerNotesEnable:bool=false;
  humanFLWorkPoolExtID:string;
  isFLNotificationEnabled:bool=false;
}
export class OrganizationsDto {
  orgExtId: string = '';
  organizationName: string = '';
  externalFieldMapping: string = '';
  id: number = 0;
  departmentParseType: string = '';
  outGoingFileNameType: string = '';
  acquisition: string = '';
  isNSDirectUpload: bool = false;
  isDelete: bool = false;
  isActive: bool = false;
  directBucket: string = '';
  parsingType: string = '';
  textFileDelimiter: string = '';
  xmlFileSourceNode: string = '';
  externalBucket: string = '';
  externalOutputFolderkey: string = '';
  stateFieldMapping: string = '';
  rushFieldMapping: string = '';
  invoiceOutputFieldMapping: string = '';
  distributionputFieldMapping: string = '';
  nsDistributionputFieldMapping: string = '';
  xmlFieldMapping: string = '';
  folderDate: string = '';
  extraFileDownloadFormat: string = '';
  requiredClientBucketSave: string = '';
  departmentSpecificFolders: bool = false;
  pgpEncryptionRequired: bool = false;
  invoice_email_list: string = '';
  teFileFormat: string = '';
  isAspose: bool = false;
  isOldProcess: bool = false;
  isProcessotherFolder: bool = false;
  processFolder: string = '';
  externalInputFolderkey: string = '';
  pgpPassword: string = '';
  pgpDecryptionRequired: bool = false;
  isIDXEnabled: bool = false;
  truncateKeyword: string = '';
  emailDistributionList: string = '';
  cutoffDuration: string = '';
  truncateFilePath: string = '';
  internalBucket: string = '';
  isOriginalFileName: bool = false;
  organizationId: string = '';
  password: string = '';
  inboundPassword: string = '';
  tenantId: number = 0;
  ConnectorId: number = 0;
  connectorPassword: string = '';
  isNSAutoUpload: bool = false;
  isAudioUploadBySAS: bool = false;
  isFutureOrder: bool = false;
  sourceType: string = '';
  isForeignLanguage: bool = false;
  isSensitive: bool = false;
  isCertification: bool = false;
  isNotarization: bool = false;
  allowMultipleJobs:bool=false;
  IsForeignLanguageFirstDraft: bool = false;
  defaultForeignLanguageService: string = '';
  defaultSourceForeignLanguage:string ='';
  isDefaultAuthorEmail: bool = false;
  defaultEmail: string = '';
  estimationMessage:string ='';
  isACKEnabled: bool = false;
  isUploadProgressively: bool = false;
  isSummaryEnabled: bool = false;
  summaryModel:string ='';
  summaryPrompt:string ='';
  isRushVisible : bool = false;
  presetPrompts : string ='';
  isCustomPromptEnable : bool = false;
  sendOrderToNSW : bool =false;
  isCourt: bool = false;
  isNetScribeLiveOnly: bool = false;
  allowAnnotations: bool = false;
  postRecordingAnnotationUpdate: bool = false;
  autoStartTranscription: bool = false;
  recordingForms: string = '';
}
export class DepartmentsDto {
  bucket: string;
  orgExtId: string;
  deptExtId: string;
  departmentName: string;
  organizationName: any;
  defaultAuthor: string;
  documentDownloadFormat: string;
  organizationId: string;
  departmentId: string;
  fieldMapping: string;
  formTypes: string;
  jobFilesFolderKey: string;
  orgId: Number;
  fileTypes: string;
  isDelete: bool;
  displayName: string;
  id: number = 0;
  inputFolderKey: string;
  awxFolderPath: string;
  requiresPDFConversion: bool;
  custTimeZone: string;
  timeDifference: number;
  defaultFormTypeId: string;
  subrogation: string;
  regions: string;
  outputFolderKey: string;
  useCaseId: string;
  field1: string;
  field2: string;
  field3: string;
  field4: string;
  field5: string;
  field6: string;
  field7: string;
  field8: string;
  field9: string;
  field10: string;
  orderIField1: any;
  orderIField2: any;
  orderIField3: any;
  orderIField4: any;
  orderIField5: any;
  orderIField6: any;
  orderIField7: any;
  orderIField8: any;
  orderIField9: any;
  orderIField10: any;
  recordingIField1: string;
  recordingIField2: string;
  recordingIField3: string;
  recordingIField4: string;
  recordingIField5: string;
  recordingIField6: string;
  recordingIField7: string;
  recordingIField8: string;
  recordingIField9: string;
  recordingIField10: string;
  orderformTypes:string;
  orderFieldMapping:string;
  RecordingFormFieldMapping: string;
  recordingFieldMapping?: string;
  recordingForms: string;
}
export class Departments {
  orgId: string;
  departmentName: string;
  deptExtId: string;
  displayName: string;
  documentDownloadFormat: string;
  formTypes: string;
  organizationName: string;
  isDelete: bool;
  field1: string;
  field2: string;
  field3: string;
  field4: string;
  field5: string;
  field6: string;
  field7: string;
  field8: string;
  field9: string;
  field10: string;
  recordingIField1: string;
  recordingIField2: string;
  recordingIField3: string;
  recordingIField4: string;
  recordingIField5: string;
  recordingIField6: string;
  recordingIField7: string;
  recordingIField8: string;
  recordingIField9: string;
  recordingIField10: string;
  orderformTypes:string;
  orderFieldMapping:string;
  RecordingFormFieldMapping: string;
  recordingFieldMapping?: string;
  recordingForms: string;
}
export class customers {
  custExtId: string;
  customerName: string;
  dbId: string;
  directBucket: string;
  id: string;
}
export class OutPutFileNameSource {
  id: string;
  fieldSource: string;
  fileNameSourceId: string;
  type: string;
}
export class Roles {
  id: string;
  createdDate: string;
  isActive: bool;
  roleName: string;
  roleDisplayName: string;
}
export class Authors {

  id: string;
  authorKey: string;
  authorValue: string;
  customerId: string;
  oneTimeSpeaker: string[];
}

export class LoginResponse {

  userStatus: string;
  userName: string;
  token: string;
  refreshtoken: string;
  expirationTime: Date;
  IsSuccess: bool;
  sessionID: string;
}
export class userStatusModel {
  userName: string;
  isActive: bool;
  status: string;
}
export class NotesDialogData {
  Notes: string;
  custNotes: string;
}
export class MediaDialogData {
  ListOfAudioFiles: File[] = [];
  ListOfOriginalFiles = [];
  canUpload: boolean = false;
  originalFile: File;
  FileType: string;
  ListzipFiles = [];
  ListOfAudioFiles1: FileToUpload[] = [];
  IsMergeAudios = false;
  ListOfMergeAudioFiles = [];
  MergeAudioFileNameList = [];
  isUploadProgressively: boolean = false;
  isRecording :boolean = false;
  recordingSessionId: string;

}
export class AttachmentsDialogData {
  ListOfAttachments: FileToUpload[] = [];
  ListOfAttachmentFiles = [];
}
export class ColorCodes {
  colorCode: string;
  colorValue: string;
}
export class transcriptionrequest {
  jobId: string;
  transcript: string ;
}
export class EstimateDialogData {
  showAcceptButton: bool;
  totalEstimateAmount: number;
  numberOfMins: number;
  jobCostMinuteRateEstimation = "";
  receiptEmail:string;
  estimateJobTypeExtId = "";
  estimateJobTypeDisplayName = "";
  selectedIndex:number;
  selectedLanguage:string;
  selectedFLlanguage:number;
  isForeignLanguage:bool;
  departmentId : string;
  deptName:string;
  deptExtId: string;
  estimationMessage: string;
}
export enum JobReleaseHoldStateEnum
{
  TypingOrEditing = 1,
  Review = 2
};
export class gridInputModel {
  query: string;
  jobColumnsList:string;
  jobColumnsListOrder:string;
  browserTimeZoneOffset:number;
  gridJobModel: any | null;
}
export class UsergridInputModel {
  query: string;
  userGridModel : any | null;
}
export class OrderInputDto {
  deptId: Number;
  organizationExtId: string = "";
  departmentExtId: string = "";
  jobTypeExtId: string = "";
  authorExtId: string = "";
  jurisdictionName: string = "";
  customerTat: string = "";
  caseNumber:number;
  hearingDate: string = "";
  format: string = "";
  language: string = "";
  highPriority: boolean = false;
  orderFormId :number;
  CreatedBy : number;
  formData: Record<string, string> = {};
  authorName: string = "";
  jobTypeDisplayName: string = "";
  attachmentFiles: FileToUpload[];
  audioFiles: FileToUpload[];
  totalEstimationCost: number;
  numberofMinutesforEstimation: number;
  perMinuteEstimationRate = "";
  previousStatusId : number;
  statusId : number;
  RequestorId : Number ;
  Notes : string;
  courtLocationName:string;
  courtLocationExtId:string;
  courtRoomName:string;
  courtRoomExtId:string;
  jurisdictionExtId:string;
  orderType:Number;
  orderDate:string;
  recordingTimes:string;
}
export class OrderStatus {
  Status: string;
  IsCompleted: boolean;
  Notes: string;
  CreatedTime: string;
  IsEdit: boolean; // Consider using Date if needed
}
export class OrderStatusUpdateDto {
  notes: string;
  statusHistoryId : number;
  statusId : number;
  status : string;
  }
export class Recording {
  sessionId: string;
  metaData: string;
  filePath: string;
  isUploaded: boolean;
  isDeleted: boolean;
  jobId: number;
  userId: number;
}
export class Jurisdictions {
  id: string;
  name:string;
  externalId:string;
}
export class CourtLocations {
  id: string;
  name: string;
  address: string;
  comment: string;
  externalId:string;
}
export class CourtRooms{
    id: string;
    name: string;
    externalId:string;
}
export interface RecordingModel {
    boundindex?: number;
    courtLocation?: string;
    courtroom?: string;
    createdAt?: Date;
    hostName?: string;
    language?: string;
    microphone?: string;
    outputPath?: string;
    recordingSessionId?: string;
    recordingSource?: string;
    roomName?: string;
    sourceSystem?: string;
    status?: string;
    translateToEnglish?: string;
    uid?: number;
    uniqueid?: string;
    visibleindex?: number;
    transcription?: string; // We'll add this for the hardcoded text
    recordingDetails?: string;
    fileName?: string; 
    startedAt?: string;
    stoppedAt?: string;
    duration?: string;
    audioChannels?: number;
    format?: string;
    id?: number;
    caseNumber?: string;
    judgeName?: string;
    hearingDateTime?: string;
    postRecordingAnnotationUpdate?: boolean;
    autoStartTranscription?: boolean;
    orgExtId?:string;
    /** Dynamic form field values captured during the recording, as a JSON string. */
    formData?: string;
}

// export class systemSettingsDto
// {
//   maintenanceMessage:string;
//   maintenanceStartTime:Date;
//   maintenanceEndTime:Date;
//   isEnable:bool;
//   editorAutoSaveInterval?:number;
//   releaseNotesFileName:string;
// }

export interface FormTypeCreate {
  name: string;
  fieldList: string;
  formTypeCatalogId: number;
  isCourtForm?: boolean;
}

export interface FormTypeUpdate {
  id: number;
  formTypeId: string;
  name: string;
  fieldList: string;
  formTypeCatalogId: number;
  isCourtForm?: boolean;
}

// ===================== Case Management =====================

export interface CasePagedResult<T> {
  totalRows: number;
  rows: T[];
}

export interface CaseProfileRoleModel {
  id?: number;
  role: string;
  description?: string;
  displayOrder: number;
  isRequired: boolean;
  allowMultiple: boolean;
  isActive: boolean;
}

export interface CaseProfileInputModel {
  id?: number;
  profileName: string;
  description?: string;
  isActive: boolean;
  orgExtId: string;
  roles: CaseProfileRoleModel[];
}

export interface CaseProfileOutputModel {
  id: number;
  profileName: string;
  description?: string;
  isActive: boolean;
  orgExtId?: string;
  createdAt?: string;
  createdBy?: string;
  lastModifiedAt?: string;
  lastModifiedBy?: string;
  roles: CaseProfileRoleModel[];
}

export interface CaseProfileListItem {
  id: number;
  profileName: string;
  description?: string;
  numberOfRoles: number;
  isActive: boolean;
  status: string;
  modifiedDate?: string;
  createdDate?: string;
}

export interface CaseProfileResponse {
  success: boolean;
  message: string;
  caseProfileId?: number;
}

// A global master role (read-only reference list, the template for first-time org setup).
export interface CaseMasterRoleModel {
  id: number;
  roleCode: string;
  displayName: string;
  description?: string;
  displayOrder: number;
}

// A role in an organization's own catalog (the source of truth after first-time setup).
export interface OrgCaseRoleModel {
  id?: number;
  orgExtId?: string;
  roleCode?: string;
  displayName: string;
  description?: string;
  displayOrder: number;
  isActive: boolean;
}

// First-time setup: copy the selected master roles into the org's catalog.
export interface AssignRolesFromMasterInput {
  orgExtId: string;
  masterRoleIds: number[];
}

// Manage Roles save: upsert/reorder roles and hard-delete the listed ids (explicit, never by omission).
export interface SaveOrgRolesInput {
  orgExtId: string;
  roles: OrgCaseRoleModel[];
  deletedRoleIds: number[];
}

export interface CasePersonModel {
  name: string;
}

export interface CaseRolePeopleModel {
  caseProfileRoleId: number;
  role: string;
  people: CasePersonModel[];
}

export interface CaseInputModel {
  id?: number;
  caseNo: string;
  caseProfileId: number;
  casePeople: CaseRolePeopleModel[];
  hearingDate?: string;
  courtRoom?: string;
  courtLocation?: string;
  orgExtId?: string;
  caseNotes?: string;
  caseStatus?: string;
}

export interface CaseOutputModel {
  id: number;
  caseNo: string;
  caseProfileId: number;
  caseProfileName?: string;
  casePeople: CaseRolePeopleModel[];
  hearingDate?: string;
  courtRoom?: string;
  courtLocation?: string;
  orgExtId?: string;
  caseNotes?: string;
  caseStatus?: string;
  isActive: boolean;
  profileRoles: CaseProfileRoleModel[];
}

export interface CaseListItem {
  id: number;
  caseNo: string;
  caseProfileId: number;
  caseProfileName?: string;
  people?: string;
  hearingDate?: string;
  courtRoom?: string;
  courtLocation?: string;
  caseStatus?: string;
  isActive: boolean;
}

export interface CaseResponse {
  success: boolean;
  message: string;
  caseId?: number;
}

export interface CaseImportRowModel {
  rowNumber: number;
  caseNo: string;
  caseProfile: string;
  hearingDate: string;
  courtRoom: string;
  courtLocation: string;
  casePeople: string;
  status: string;
  caseNotes: string;
}

export interface CaseImportRequest {
  rows: CaseImportRowModel[];
  strategy: number; // 0 = InsertOnly, 1 = InsertOrUpdate, 2 = RejectDuplicates
  orgExtId?: string;
}

export interface CaseImportRowError {
  rowNumber: number;
  caseNo: string;
  errorMessage: string;
}

export interface CaseImportResult {
  total: number;
  successful: number;
  failed: number;
  duplicate: number;
  errors: CaseImportRowError[];
}
